import cx from "classnames";
import { Button, Container } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import React from "react";
import _ from "lodash";

import Alert from "components/shared/common/alert";
import soundIcon from "assets/images/bingo/sound-icon.png";
import qrCodeBtn from "assets/images/slide-kick/qr-code.png";
import soundCloseIcon from "assets/images/bingo/soundClose.png";
import hpwToClose from "assets/images/charty-party/x-circle.png";
import { end_Game } from "components/shared/utils";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as socketAction from "redux/sockets/action";
import * as paramsAction from "redux/gameParams/actions";
import Socket from "socket/socket";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      howToPlayPopup: false,
      params: "",
      bingo_volume_DropDown: true,
      volumeLevel: 0.2
    };
  }

  toggle_bingo_volume_button = () =>
    this.setState({ bingo_volume_DropDown: !this.state.bingo_volume_DropDown });

  componentDidMount() {
    this.setState({
      params: _.get(this.props, "paramsReducer.gameObj.presenting")
    });
  }

  onEndGame = () => {
    let roomData = this.props.gameReducer.roomObj;
    end_Game(roomData, this.props);
  };

  toggleHowToPlay = () =>
    this.props.toggleHowToPlay(!this?.props?.socketReducer?.howToPlay);

  toggleSlideKickQR = () =>
    this.props.toggleSlideKickQR(!this?.props?.socketReducer?.slide_QR);

  setVolumeLevel = (vol) => this.props.setVolumeLevel(vol);

  static getDerivedStateFromProps(nextProps, prevState) {
    const { roomObj } = nextProps.gameReducer;
    if (
      window.location.pathname !== "/" &&
      roomObj &&
      roomObj.active_game === false
    ) {
      nextProps.endGame(true);
      nextProps.history.push("/");
    }
  }

  addClue = () => {
    let roomData = this.props.gameReducer.roomObj;
    let data = {
      action: "submit-clue",
      roomId: roomData.id,
      clue: "clue1",
      playerId: 1
    };
    Socket.sendMessage(data);
  };

  submitGuess = () => {
    let roomData = this.props.gameReducer.roomObj;
    let data = {
      action: "leave-room",
      roomId: roomData.id,
      playerId: 1
    };
    Socket.sendMessage(data);
  };

  nextRound = () => {
    let roomData = this.props.gameReducer.roomObj;
    let data = {
      action: "right-guess",
      roomId: roomData.id
    };
    Socket.sendMessage(data);
  };

  wrongGuess = () => {
    let roomData = this.props.gameReducer.roomObj;
    let data = {
      action: "wrong-guess",
      roomId: roomData.id
    };
    Socket.sendMessage(data);
  };

  forceGameToNextStage = () => {
    let roomData = this.props.gameReducer.roomObj;
    if (roomData.game_code !== "TOT") {
      let data = {
        action: "update-status",
        roomId: roomData.id
      };
      Socket.sendMessage(data);
    } else {
      let data = {
        action: "update-status",
        roomId: roomData.id,
        tableTopName: roomData.tabletop.tabletop_name,
        timer: roomData.game_state.game_parameters.timer,
        doubleRounds:
          roomData.game_state.game_parameters.total_rounds >
          roomData.users.length,
        category: roomData.game_state.current_category || "Sports"
      };
      Socket.sendMessage(data);
    }
  };

  howToPlay = () =>
    this.setState({ howToPlayPopup: !this.state.howToPlayPopup });

  slideKickFooter = (roomData) => {
    let slideKickRecord = [
      { title: this.state.params?.participants, value: roomData?.users.length },
      { title: this.state.params?.join_code, value: roomData.join_code }
    ];

    return (
      <Container fluid>
        <div className="d-flex align-items-center justify-content-between footerWrapper">
          <div className="scoresHolder">
            <button
              className="slideKick-endgame-btn"
              onClick={() => this.onEndGame()}
            >
              {" "}
              END
            </button>
            {slideKickRecord &&
              slideKickRecord.map(({ title, value }, index) => (
                <div key={index} className="scoresWrapper">
                  <p className="mb-0 scoreTitle">{title}</p>
                  <div className="count d-flex justify-content-center align-items-center">
                    <p className="mb-0">{value}</p>
                  </div>
                </div>
              ))}
            <button className="qr-btn">
              <img
                className="qr-img"
                onClick={() => this.toggleSlideKickQR()}
                src={qrCodeBtn}
                alt=""
              ></img>
            </button>
          </div>
        </div>
      </Container>
    );
  };
  joinRoom = (title) => {
    const branch_redirect_domain =
      this?.props?.gameReducer?.gamesData?.branch_redirect_domain;
    const link = this?.props?.gameReducer?.branchlink?.url;

    if (title === "Join Code") {
      const branchLinkSplit = link.split("/")[3];
      let copyToClip = `${branch_redirect_domain}${branchLinkSplit}`;
      var textArea = document.createElement("textarea");
      document.body.append(textArea);
      document.body.lastElementChild.value = copyToClip;
      document.body.lastElementChild.select();
      document.execCommand("copy");
      textArea.remove();
      Alert(200, "Link copied successfully");
    }
  };
  handleMute = () => {
    let volume = this?.props?.socketReducer?.volume;
    if (volume !== 0) {
      this.setVolumeLevel(0);
    } else {
      this.setVolumeLevel(0.125);
    }
  };

  render() {
    const status = _.get(this.props, "gameReducer.roomObj.game_state.status");
    const volume_level = this?.props?.socketReducer?.volume;

    const {
      verboden = false,
      tot = false,
      dw20 = false,
      OCH = false,
      GAH = false,
      CHPT = false,
      TW = false,
      BNG = false,
      slideKick = false
    } = this.props;
    let roomData = this.props.gameReducer.roomObj;
    let gameCode =
      roomData && roomData.game_code ? roomData.game_code.toLowerCase() : "";
    if (roomData && roomData.game_code === "GAH") {
      gameCode = "gif";
    }
    if (roomData && roomData.game_code === "TW") {
      gameCode = "tw";
    }
    const gameObj = this.props.paramsReducer.gameObj;
    const text = _.get(gameObj, `screens[${gameCode}].button_text`);
    let endGameText = "";
    let timesUpText = "";
    let splitTimeText = text ? text.split("'") : "";
    if (roomData && roomData?.game_code && this.props?.paramsReducer?.gameObj) {
      if (
        this.props?.paramsReducer?.gameObj?.screens &&
        this.props?.paramsReducer?.gameObj?.screens[`${gameCode}`] &&
        this.props?.paramsReducer?.gameObj?.screens[`${gameCode}`]
          .end_button_text
      ) {
        endGameText =
          this.props?.paramsReducer?.gameObj?.screens[`${gameCode}`]
            .end_button_text;
        timesUpText =
          this?.props?.paramsReducer?.gameObj?.screens[`${gameCode}`]
            .button_text;
      }
      if (roomData.game_code === "CHPT") {
        timesUpText =
          this?.props?.paramsReducer?.gameObj?.screens?.chpt?.times_up;
        endGameText =
          this?.props?.paramsReducer?.gameObj?.screens?.chpt?.end_game;
      }
      if (roomData.game_code === "DW20") {
        timesUpText =
          this?.props?.paramsReducer?.gameObj?.screens?.dw?.button_text;
        endGameText =
          this?.props?.paramsReducer?.gameObj?.screens?.dw?.end_button_text;
      }
      if (roomData.game_code === "BNG") {
        timesUpText = "Time’s Up";
        endGameText = "End Game";
      }
      if (roomData.game_code === "SK") {
        endGameText = "End Game";
      }
    }

    let currentRound =
      roomData && Object.keys(roomData).length > 0
        ? roomData.game_state.current_round
        : 0;
    let maxRounds = _.get(
      roomData,
      "game_state.game_parameters.total_rounds",
      2
    );
    const gameData = roomData;
    let wrongWords = [];
    let rightWords = [];
    let groupScoreValue = "0/0";

    if (gameData) {
      if (gameData?.game_state?.wrong_words) {
        wrongWords = gameData.game_state.wrong_words;
      }
      if (this.props.tot) {
        if (gameData?.game_state?.skipped_words) {
          wrongWords = gameData.game_state.skipped_words;
        }
      }
      if (gameData?.game_state?.right_words) {
        rightWords = gameData.game_state.right_words;
      }

      groupScoreValue = `${rightWords.length - wrongWords.length}`;
    }

    if (roomData && roomData.game_code === "TW") {
      maxRounds = _.get(roomData, "game_state.max_rounds", 2);
    }

    let record = [
      {
        title: "Group Score",
        value: groupScoreValue < 0 ? 0 : groupScoreValue
      },
      { title: "Current Round", value: `${currentRound}/${maxRounds}` },
      { title: "Join Code", value: roomData.join_code }
    ];
    if (roomData && roomData.game_code === "OCH") {
      let currentRound = 1;
      if (roomData.game_state && roomData.game_state.current_round) {
        currentRound = roomData?.game_state?.current_round;
      }
      record = [
        {
          title: "Round",
          value: (
            <span className="roundText">
              {currentRound}
              <span className="roundText2">/</span>
              <span className="roundText">
                {roomData?.game_state?.game_parameters?.total_rounds || 4}
              </span>
            </span>
          )
        },
        { title: "Join Code", value: roomData.join_code }
      ];
    }

    if (roomData && roomData.game_code === "DW20") {
      let scoreToWin = "Loading";
      if (roomData.game_state && roomData.game_state.game_parameters) {
        scoreToWin = roomData.game_state.game_parameters.score_to_win;
      }
      record = [
        { title: "Score to win", value: scoreToWin },
        { title: "Join Code", value: roomData.join_code }
      ];
    }
    if (roomData && roomData.game_code === "GAH") {
      let scoreToWin = "Loading";
      if (roomData.game_state && roomData.game_state.game_parameters) {
        scoreToWin = roomData.game_state.game_parameters.score_to_win;
      }
      record = [
        { title: "Score to win", value: scoreToWin },
        { title: "Join Code", value: roomData.join_code }
      ];
    }
    if (roomData && roomData.game_code === "VB") {
      let currentRound = 1;
      if (roomData.game_state && roomData.game_state.current_round) {
        currentRound = roomData.game_state.current_round;
      }
      record = [
        { title: "Round", value: `${currentRound}/${maxRounds}` },
        { title: "Join Code", value: roomData.join_code }
      ];
    }
    if (roomData && roomData.game_code === "CHPT") {
      let scoreToWin = "Loading";
      if (roomData.game_state && roomData.game_state.game_parameters) {
        scoreToWin = roomData.game_state.game_parameters.score_to_win;
      }
      record = [
        { title: "Score to win", value: scoreToWin },
        { title: "Join Code", value: roomData.join_code }
      ];
    }
    if (roomData && roomData.game_code === "BNG") {
      record = [{ title: "Join Code", value: roomData.join_code }];
    }
    let isdisabled = false;
    if (
      roomData &&
      roomData.game_state &&
      roomData.game_state.status === "Over"
    ) {
      isdisabled = true;
    }

    return (
      <footer
        id="footer"
        className={cx({
          verboden,
          tot,
          dw20,
          OCH,
          GAH,
          CHPT,
          BNG,
          TW,
          slideKick
        })}
        style={{
          zIndex:
            roomData.game_code === "CHPT" &&
            roomData.game_state.status === "Over"
              ? 99999
              : dw20
              ? 99999
              : this.props.webUrlReducer.viewerWebUrl
              ? 999
              : 99999
        }}
      >
        {slideKick ? (
          this.slideKickFooter(roomData)
        ) : (
          <Container fluid>
            <div className="d-flex align-items-center justify-content-between footerWrapper">
              <Button
                onClick={() => this.onEndGame()}
                color={
                  verboden
                    ? "themePink"
                    : CHPT
                    ? "charityThemePurple"
                    : dw20
                    ? "themePurple"
                    : BNG
                    ? "bingo-end-game"
                    : OCH
                    ? "ochThemeGreen"
                    : TW
                    ? "light"
                    : "light"
                }
                className={cx({
                  "endGameBtn rounded text-nowrap":
                    !verboden && !tot && !dw20 && !OCH && !CHPT && !BNG
                })}
              >
                {endGameText}
              </Button>
              <div className="scoresHolder">
                {BNG &&
                  (this.state.bingo_volume_DropDown ? (
                    <div className="volume-btn">
                      <button onClick={this.toggle_bingo_volume_button}>
                        Volume
                      </button>
                    </div>
                  ) : (
                    <div className="test-volume">
                      <div className="volume-bars">
                        <div
                          onClick={() => this.setVolumeLevel(0.125)}
                          className={
                            volume_level < 0.125 ? "bar-emty" : "bar-1"
                          }
                        >
                          <div className="bar"></div>
                        </div>
                        <div
                          onClick={() => this.setVolumeLevel(0.25)}
                          className={volume_level < 0.25 ? "bar-emty" : "bar-2"}
                        >
                          <div className="bar"></div>
                        </div>
                        <div
                          onClick={() => this.setVolumeLevel(0.375)}
                          className={
                            volume_level < 0.375 ? "bar-emty" : "bar-3"
                          }
                        >
                          <div className="bar"></div>
                        </div>
                        <div
                          onClick={() => this.setVolumeLevel(0.5)}
                          className={volume_level < 0.5 ? "bar-emty" : "bar-4"}
                        >
                          <div className="bar"></div>
                        </div>
                      </div>
                      <div className="sound-icon-wrap">
                        <button className="sound-icon">
                          <img
                            onClick={() => this.handleMute()}
                            src={
                              volume_level < 0.1 ? soundCloseIcon : soundIcon
                            }
                            className="sound-img"
                            alt="sound"
                          />
                        </button>
                      </div>
                      <button
                        onClick={() =>
                          this.setState({
                            bingo_volume_DropDown: !this.bingo_volume_DropDown
                          })
                        }
                        className="volume-btn-opened"
                      >
                        Volume
                      </button>
                    </div>
                  ))}
                {record &&
                  record.map(({ title, value }, index) => (
                    <div key={index} className="scoresWrapper">
                      <p className="mb-0 scoreTitle">{title}</p>
                      <div
                        onClick={() => {
                          this.joinRoom(title);
                        }}
                        className="count copy-icon-footer"
                      >
                        <p className="mb-0">{value}</p>
                        {title === "Join Code" && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path
                              className="copy-icon"
                              fill={
                                BNG === true
                                  ? "#205fc7"
                                  : tot || verboden
                                  ? "white"
                                  : "black"
                              }
                              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                  ))}
                {BNG && (
                  <div className="bingo-btn-container">
                    <button
                      onClick={this.toggleHowToPlay}
                      className="bingo-how-to-play-btn"
                    >
                      how to play
                    </button>
                  </div>
                )}
              </div>

              <Button
                disabled={isdisabled}
                onClick={() => this.forceGameToNextStage()}
                color={
                  verboden
                    ? "themeBlue"
                    : CHPT
                    ? "charityThemeOrange"
                    : dw20
                    ? "yellow"
                    : OCH
                    ? "ochThemeGreen"
                    : BNG
                    ? "bingo-times-up-btn"
                    : TW
                    ? "TwgreenBtn"
                    : "light"
                }
                className={cx({
                  "timeBtn rounded text-nowrap":
                    !verboden && !tot && !dw20 && !OCH && !CHPT && !BNG,
                  "timeBtn text-nowrap": tot,
                  "chpt-over-hidden": CHPT && status === "Over"
                })}
              >
                {OCH ? (
                  <>
                    {splitTimeText[0]}
                    <span className="och-timesup">'</span>
                    {splitTimeText[1]}
                  </>
                ) : (
                  <>{timesUpText}</>
                )}
              </Button>
            </div>
          </Container>
        )}

        {this.state.howToPlayPopup && (
          <div className="back_drop_howtoplay_charty">
            <div className="howtoplay_main_charty">
              <div className="close_btn">
                <button
                  onClick={() => this.setState({ howToPlayPopup: false })}
                  className="close-btn"
                >
                  <img src={hpwToClose} alt="" />
                </button>
              </div>
              <div className="title">
                <h3>HOW TO PLAY</h3>
              </div>
              <div className="containt">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Blandit pretium semper sit cursus proin amet morbi mi dapibus.
                  Mauris nulla in ultricies in. Maecenas eu, purus, molestie
                  tortor. Velit enim, consequat, semper justo sit imperdiet
                  tincidunt risus enim. Eu, risus est pretium non tortor nibh
                  orci morbi egestas.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Blandit pretium semper sit cursus proin amet morbi mi dapibus.
                  Mauris nulla in ultricies in. Maecenas eu, purus, molestie
                  tortor. Velit enim, consequat, semper justo sit imperdiet
                  tincidunt risus enim. Eu, risus est pretium non tortor nibh
                  orci morbi egestas.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Blandit pretium semper sit cursus proin amet morbi mi dapibus.
                  Mauris nulla in ultricies in. Maecenas eu, purus, molestie
                  tortor. Velit enim, consequat, semper justo sit imperdiet
                  tincidunt risus enim. Eu, risus est pretium non tortor nibh
                  orci morbi egestas.
                </p>
              </div>
            </div>
          </div>
        )}
      </footer>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  socketReducer: state.socketReducer,
  webUrlReducer: state.webUrlReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
    setVolumeLevel: (data) => dispatch(socketAction.setVolumeLevel(data)),
    toggleHowToPlay: (data) => dispatch(socketAction.toggleHowToPlay(data)),
    toggleSlideKickQR: (data) => dispatch(socketAction.toggleSlideKickQR(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Footer);
